// import { getCollapsiblePanelStyles } from '../../shared/styles';
import _ from 'underscore';
import { merge } from '@bingads-webui/primitive-utilities';
import { creationCommonStyle } from '@bingads-webui-campaign-react/campaign-adgroup-settings-shared-styles';

function resolveStyles({ theme }, ...styles) {
  const resolvedStyles = styles.map(s => (_.isFunction(s) ? s(theme) : s));

  if (_.some(resolvedStyles, _.isEmpty)) {
    throw new Error('Cannot pass in empty style!');
  }

  return resolvedStyles;
}

export const getCampaignStyles = (components, theme) => ({
  divider: {
    padding: '5px 0px 0px 4px',
    width: '100%',
    borderTop: '2px solid #E0E0E0',
    marginTop: 30,
    marginBottom: 20,
  },
  budgetContainer: {
    '& .budget-title-container span': {
      fontWeight: 600,
    },
  },
  campaignShell: {
    display: 'flex',
    width: 966,
    '& .ms-ChoiceFieldGroup label': {
      padding: 0,
      fontWeight: 400,
    },
    ...merge(
      {},
      ...resolveStyles(
        { theme },
        creationCommonStyle
      )
    ),
    '& .local-inventory label': {
      display: 'flex',
    },
    '& .product-collections label': {
      display: 'flex',
    },
    '& .productsScope': {
      display: 'none',
    },
    '& .bid-strategy-details-container label': {
      display: 'inline-block',
    },
    '& .bid-and-budget #currencyLabelCostPerSale': {
      display: 'inline',
    },
    '& .allFeedProducts': {
      display: 'none',
    },
  },
  collapsiblePanel: {},
  estimationPart: {
    flexGrow: '1',
    position: 'sticky',
    marginTop: '58px',
    marginLeft: '30px',
  },
  urlOptionsContainer: {
    maxWidth: 435,
  },
});
